import { render, staticRenderFns } from "./externalBookingSummary.vue?vue&type=template&id=23be8e05"
import script from "./externalBookingSummary.vue?vue&type=script&lang=js"
export * from "./externalBookingSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports